import styled from 'styled-components';

import { Box } from '../../common/ui/Box';

export const ApprovalRequestContentContainer = styled(Box).attrs({
    display: 'grid',
    gap: 48,
    padding: 48,
    maxWidth: '1200px',
    marginX: 'auto',
})``;
